import React from "react";
import Cart from "./Cart";
import ModalContainer from "../modal/modal-container";

const CartModal = ({ event, closeModal, modalBackButton }) => {
  return (
    <ModalContainer modalBackButton={modalBackButton} closeModal={closeModal}>
      <section>
        <Cart event={event} />
      </section>
    </ModalContainer>
  );
};

export default CartModal;
